export const actionTypes = {
  GET_INFO: 'APP.OLD_VERSION_TOKEN.GET_INFO',
  GET_INFO_SKIP_LOADING: 'APP.OLD_VERSION_TOKEN.GET_INFO.SKIP_LOADING',
  REQUEST_SUCCESS: 'APP.OLD_VERSION_TOKEN.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'APP.OLD_VERSION_TOKEN.REQUEST_FAILURE',
};

export function getOldVersionToken(isMessagePage) {
  return {
    type: actionTypes.GET_INFO,
    payload: isMessagePage,
  };
}

export function getOldVersionSkipLoading() {
  return {
    type: actionTypes.GET_INFO_SKIP_LOADING,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
